import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  CalendarMaxDate,
  FiltersState,
  IRangeDateInfo,
  PeriodType,
  PeriodTypeToLabel,
  RangePickerType,
  SetFilters
} from '@lla-platform/core/core-data-access'
import { DateService, FullScreenModalConfig, MobileMaxWidth } from '@lla-platform/core/core-util'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'
import { cloneDeep } from 'lodash'
import { RangeDatePickerDialogComponent } from '../range-date-picker-dialog/range-date-picker-dialog.component'

@UntilDestroy()
@Component({
  selector: 'lla-range-date-picker-filter',
  templateUrl: './range-date-picker-filter.component.html',
  styleUrls: ['./range-date-picker-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RangeDatePickerFilterComponent implements OnChanges {
  @Input() value: IRangeDateInfo
  @Input() maxDate: CalendarMaxDate = 'Today'
  @Input() minDate?: string
  @Input() hiddenPeriods: PeriodType[] = []
  @Input() hideAllPeriods = false
  @Input() showMoonLanding = false
  @Input() extraClasses = ''
  @Input() enableRangePickerType = false

  @Output() valueChanged = new EventEmitter<IRangeDateInfo>()

  rangePickerType: RangePickerType
  selectedRangePickerType: RangePickerType
  formattedPeriodTime?: string = ''
  displayPeriodValue = ''
  selectedValue: IRangeDateInfo
  selectedPeriodType?: PeriodType
  periodTypeToLabel = PeriodTypeToLabel
  menuIsOpen = false

  window = window
  mobileMaxWidth = MobileMaxWidth

  constructor(
    private store: Store,
    private dateService: DateService,
    private dialogService: MatDialog
  ) {}

  ngOnChanges(): void {
    this.setSelectedDate()
  }

  setSelectedDate() {
    this.selectedValue = cloneDeep(this.value)
    this.selectedPeriodType = this.selectedValue?.periodType
    this.formattedPeriodTime = this.dateService.momentCalculatedFormattedPeriod(this.value?.rangeDate)
    const periodLabel = this.selectedPeriodType ? this.periodTypeToLabel[this.selectedPeriodType] : ''
    this.displayPeriodValue = this.formattedPeriodTime
      ? periodLabel
        ? `${periodLabel}: ${this.formattedPeriodTime}`
        : this.formattedPeriodTime
      : ''
  }

  onMenuOpened() {
    const rangePickerTypeFilter = this.store.selectSnapshot(FiltersState.rangePickerType)
    this.rangePickerType =
      this.enableRangePickerType && rangePickerTypeFilter ? rangePickerTypeFilter : 'daily'
    this.menuIsOpen = true
  }

  onRangePickerTypeChange(type: RangePickerType) {
    if (this.enableRangePickerType) {
      this.selectedRangePickerType = type
    }
  }

  saveRangePickerType() {
    if (this.enableRangePickerType && this.selectedRangePickerType) {
      this.store.dispatch(new SetFilters({ rangePickerType: this.selectedRangePickerType }))
    }
  }

  openDatePickerModal() {
    this.dialogService
      .open(RangeDatePickerDialogComponent, {
        ...FullScreenModalConfig,
        data: {
          selectedValue: this.selectedValue,
          maxDate: this.maxDate,
          minDate: this.minDate,
          hideAllPeriods: this.hideAllPeriods,
          hiddenPeriods: this.hiddenPeriods,
          showMoonLanding: this.showMoonLanding,
          enableRangePickerType: this.enableRangePickerType
        }
      })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((res: IRangeDateInfo) => {
        if (!res) {
          return
        }
        this.valueChanged.emit(res)
      })
  }
}
